module.exports = __webpack_public_path__ + "img/pet_ok.7f750dab.png";